import { remCalc } from '@/config/design';
export const derivedThemeValues = generator => {
  return _ref => {
    let {
      theme
    } = _ref;
    // Extract base values
    const baseRem = theme.base.rem;
    const basePadding = theme.base.padding;
    const baseRadius = theme.base.radius;
    return generator({
      theme: theme,
      remCalc: value => remCalc(value, baseRem),
      padding: function () {
        let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        return remCalc(value * basePadding, baseRem);
      },
      radius: function () {
        let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        return remCalc(value * baseRadius, baseRem);
      }
    });
  };
};
export const combineDerivedThemeValues = generators => {
  return _ref2 => {
    let {
      theme
    } = _ref2;

    function computeValues(generators) {
      return Object.keys(generators).reduce((acc, key) => {
        if (typeof generators[key] !== 'function') {
          acc[key] = generators[key];
        } else {
          acc[key] = generators[key]({
            theme
          });
        }

        return acc;
      }, {});
    }

    return computeValues(generators);
  };
};